const applications = [
  {
    sector: 'Agriculture & Farming',
    icon: 'ri-seedling-line',
    image: 'https://readdy.ai/api/search-image?query=Australian%20farmer%20standing%20in%20wheat%20field%20with%20wind%20turbines%20in%20the%20background%2C%20golden%20crops%2C%20blue%20sky%2C%20rural%20Australian%20landscape%2C%20dual-use%20land%20farming%20and%20wind%20energy%2C%20lifestyle%20photography&width=600&height=420&seq=wind-app-farm-2026&orientation=landscape',
    description: 'Landowners lease their land to wind developers and continue farming around turbines. Annual lease income of $10,000–$50,000 per turbine provides a substantial second income stream with zero disruption to farming operations.',
    tags: ['Lease income $10K–$50K/turbine/yr', 'Dual land use', 'No farming disruption'],
    color: 'border-primary-200 bg-primary-50/30',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    sector: 'Mining & Resources',
    icon: 'ri-hammer-line',
    image: 'https://readdy.ai/api/search-image?query=Remote%20Australian%20mining%20operation%20with%20wind%20turbines%20and%20solar%20panels%20providing%20energy%2C%20outback%20landscape%2C%20industrial%20infrastructure%2C%20hybrid%20renewable%20energy%20microgrid%2C%20professional%20aerial%20photography&width=600&height=420&seq=wind-app-mining-2026&orientation=landscape',
    description: 'Remote mining operations spend millions annually on diesel generation. Hybrid wind-solar-battery microgrids can replace 70–100% of diesel fuel, delivering massive cost savings and meeting investor ESG requirements.',
    tags: ['Replace 70–100% of diesel', 'ESG compliance', 'Stranded asset mitigation'],
    color: 'border-secondary-200 bg-secondary-50/30',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    sector: 'Manufacturing & Industry',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Australian%20industrial%20manufacturing%20plant%20with%20green%20clean%20energy%20concept%2C%20wind%20turbines%20visible%20outside%20facility%2C%20professional%20industrial%20photography%2C%20sustainability%20and%20innovation%20theme&width=600&height=420&seq=wind-app-mfg-2026&orientation=landscape',
    description: "Manufacturers facing rising energy costs and carbon reporting obligations are locking in Corporate PPAs with wind farms. A long-term PPA fixes electricity costs for 10–20 years — providing budget certainty while meeting customers' and investors' sustainability expectations.",
    tags: ['10–20 year fixed prices', 'Carbon accounting', 'Scope 2 reduction'],
    color: 'border-accent-200 bg-accent-50/30',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    sector: 'Remote Communities',
    icon: 'ri-home-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Remote%20Australian%20Aboriginal%20community%20or%20outback%20township%20with%20small%20wind%20turbines%20and%20solar%20panels%20providing%20electricity%2C%20community%20energy%20independence%2C%20warm%20lighting%2C%20sustainable%20living%20concept%2C%20editorial%20photography&width=600&height=420&seq=wind-app-remote-2026&orientation=landscape',
    description: "Australia's remote communities and off-grid towns benefit enormously from hybrid wind-solar-battery systems. ARENA funding supports these projects, which can deliver 24/7 reliable electricity and eliminate costly diesel dependence in communities where grid connection is uneconomical.",
    tags: ['ARENA-funded programs', 'Grid independence', '24/7 reliable power'],
    color: 'border-primary-200 bg-primary-50/30',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function WindApplications() {
  return (
    <section className="bg-background-100/50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-50 border border-secondary-200/50 mb-5">
            <i className="ri-apps-line text-secondary-600 text-sm"></i>
            <span className="text-xs font-semibold text-secondary-700 tracking-wide uppercase whitespace-nowrap">Applications</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4">
            Who Benefits from<br className="hidden md:block" /> Wind Energy in Australia?
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Wind energy delivers real economic and environmental value across diverse sectors — from farming to heavy industry to remote communities.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-7">
          {applications.map((app) => (
            <article key={app.sector} className={`rounded-2xl border overflow-hidden ${app.color} transition-all duration-200 hover:shadow-sm`}>
              <div className="relative">
                <img
                  src={app.image}
                  alt={`Wind energy for ${app.sector} in Australia`}
                  className="w-full h-52 object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent" />
                <div className="absolute bottom-3 left-4 flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-white/90 flex items-center justify-center">
                    <i className={`${app.icon} text-secondary-600 text-sm`}></i>
                  </div>
                  <span className="font-heading text-sm font-bold text-white">{app.sector}</span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{app.description}</p>
                <div className="flex flex-wrap gap-2">
                  {app.tags.map((tag) => (
                    <span key={tag} className={`text-xs font-semibold px-2.5 py-1 rounded-full ${app.tagColor} whitespace-nowrap`}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}